import { render, staticRenderFns } from "./WorkScheduleBar.vue?vue&type=template&id=2b884aae&scoped=true&"
import script from "./WorkScheduleBar.vue?vue&type=script&lang=js&"
export * from "./WorkScheduleBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkScheduleBar.vue?vue&type=style&index=0&id=2b884aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b884aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VContainer,VLayout,VRow,VTooltip})
